const doc = [({"da":({"js":({"preview":({"preview":"Preview", "open":"Åben"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;